class FootnoteIcons {
  constructor() {
    this.replaceTextWithIcon();
  }

  replaceTextWithIcon() {
    const footnoteContainers = document.querySelectorAll('.ns-footnote-container');
    footnoteContainers.forEach(container => {
      const footnoteKeys = container.querySelectorAll('.ns-footnote__key');

      footnoteKeys.forEach(key => {
        const text = key.innerText.trim();
        if (text.includes('diamond') || text.includes('<diamond>')) {
          key.classList.add('ns-style-diamond');
        } else if (text.includes('square') || text.includes('<square>')) {
          key.classList.add('ns-style-square');
        } else if (text.includes('triangle') || text.includes('<triangle>')) {
          key.classList.add('ns-style-triangle');
        }
      });
    });
  }
}

export default FootnoteIcons;
